import React from 'react';
import { Container, Spinner, Row, Col, Button } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import 'date-fns';
import { dateFormatUtil ,getFormattedDateTime,getFormattedDate} from '../Utilities';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import Form from 'react-bootstrap/Form';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Multiselect from 'multiselect-react-dropdown';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

import {
    BarChart,
    Bar,
    Brush,
    Pie,
    ReferenceLine,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    PieChart,
    Sector,
    Cell,
    LineChart,
    Line
} from 'recharts';

export function MaterialUIPickers(props) {
    if (props.id == 'date-picker-inline1') {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = new Date(y, m, 1);
    } else {
        var firstDay = new Date();
    }
    const [selectedDate, setSelectedDate] = React.useState(firstDay);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container justifyContent="space-around">
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id={props.id}
                    label={props.label}
                    value={selectedDate}
                    onChange={handleDateChange}
                    autoOk={true}
                    maxDate={
                        props.id == 'date-picker-inline2' ? new Date() : ''
                    }
                    keyboardbuttonprops={{
                        'aria-label': 'change date'
                    }}
                />
            </Grid>
        </MuiPickersUtilsProvider>
    );
}

const StaticsData = [];
const StaticsDataMonthly = [];
const COLORS = [
    '#0088FE',
    '#00C49F',
    '#FFBB28',
    '#FF8042',
    '#ff0000',
    '#fe0000',
    '#ddffff'
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index
}) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
        <text
            x={x}
            y={y}
            fill="white"
            textAnchor={x > cx ? 'start' : 'end'}
            dominantBaseline="central"
        >
            {`${(percent * 100).toFixed(2)}%`}
        </text>
    );
};

class ProfileChart extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            alert: 0,
            showOrderType:0,
            totalOrderCount: 0,
            totalOrderValues: 0,
            t_totalOrderCount: 0,
            t_totalOrderValues: 0,
            showChart: 1,
            showOrder: 1,
            chartData: [],
            tagOptions: [],
            selectedTags: [],
            AllSelectedTagsStoreTags: [],
            AllStoreTags: [],
            AllStatics: [],
            AllStaticsFiltered: [],
            AllCustomStatics: [],
            LastUpdated: '',
            alertMessage: '',
            loading: true,
            loadingCustom: false,
            loadingChart: false,
            showDatePicker: false,
            customFromDate: this.getCustomFormattedDate('dateFrom'),
            customToDate: this.getCustomFormattedDate('dateTo'),

            fromDate: this.getDateFromTo('dateFrom'),
            toDate: this.getDateFromTo('dateTo'),

            last7DaysFrom: this.getLast7DaysDates('dateFrom'),
            last7DaysTo: this.getLast7DaysDates('dateTo'),

            last7DaysArray: this.get7DaysArray(),
            last7WeeksArray: this.get7WeeksArray(),
            last7MonthsArray: this.get7MonthsArray(),
            monthNames: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ]
        };
    }

    get7DaysArray() {
        let daysArray = [];
        var mydate = new Date();
        for (var i = 0; i < 7; i++) {
            mydate.setDate(mydate.getDate() - 1);
            var D1Month = String(mydate.getMonth() + 1).padStart(2, '0');
            var dd1 = String(mydate.getDate()).padStart(2, '0');
            var date = mydate.getFullYear() + '-' + D1Month + '-' + dd1;
            daysArray.push(date);
        }

        return daysArray;
    }
    get7WeeksArray() {
        let datesArray = [];
        var mydate = new Date();
        for (var i = 0; i < 7; i++) {
            var mydate = new Date();
            mydate.setDate(mydate.getDate() - i * 7);
            var weekNumberDate = this.getWeek(mydate);
            datesArray.push(weekNumberDate);
        }
        return datesArray;
    }

    getWeek(date1) {
        var oneJan = new Date(date1.getFullYear(), 0, 1);
        var numberOfDays = Math.floor((date1 - oneJan) / (24 * 60 * 60 * 1000));
        var numberOfDaysStart = Math.floor(numberOfDays - 7);
        var result = Math.ceil((date1.getDay() + 1 + numberOfDaysStart) / 7);
        return date1.getFullYear() + '-' + result;
    }

    get7MonthsArray() {
        let monthsArray = [];
        var date = new Date();
        let monthNumber = date.getMonth() + 1;
        var today = new Date();

        for (var i = 1; i < 8; i++) {
            var dSeven = new Date(
                today.getFullYear(),
                today.getMonth() - i * 1,
                1
            );
            monthsArray.push(
                dSeven.getFullYear() + '-' + String(dSeven.getMonth() + 1)
            );
        }
        return monthsArray;
    }

    generateColor() {
        const randomColor = Math.floor(Math.random() * 16777215)
            .toString(16)
            .padStart(6, '0');
        return '#' + randomColor;
    }

    getWeekDates(dateType) {
        var date = new Date();
        var oneJan = new Date(date.getFullYear(), 0, 1);
        var numberOfDays = Math.floor((date - oneJan) / (24 * 60 * 60 * 1000));

        var weekNumber = Math.ceil((date.getDay() + 1 + numberOfDays) / 7);

        var numberOfDaysStart = Math.floor(numberOfDays - 49);
        var weekNumber7 = Math.ceil(
            (date.getDay() + 1 + numberOfDaysStart) / 7
        );

        if (dateType == 'dateFrom') {
            return date.getFullYear() + '-' + weekNumber7;
        } else {
            return date.getFullYear() + '-' + weekNumber;
        }
    }

    getLast7DaysDates(dateType) {
        var today = new Date();
        var dateDaysStart = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
        var dateDaysEnd = new Date(today.getTime() - 1 * 24 * 60 * 60 * 1000);

        var D1Month = dateDaysStart.getMonth() + 1;
        var D2Month = dateDaysEnd.getMonth() + 1;

        var dd1 = String(dateDaysStart.getDate()).padStart(2, '0');
        var mm1 = String(dateDaysStart.getMonth() + 1).padStart(2, '0');

        var dd2 = String(dateDaysEnd.getDate()).padStart(2, '0');
        var mm2 = String(dateDaysEnd.getMonth() + 1).padStart(2, '0');

        if (dateType == 'dateFrom') {
            return dateDaysStart.getFullYear() + '-' + mm1 + '-' + dd1;
        } else {
            return today.getFullYear() + '-' + mm2 + '-' + dd2;
        }
    }

    getLast7MonthsDates(dateType) {
        var date = new Date();
        let monthNumber = date.getMonth() + 1;
        var today = new Date();

        var dSeven = new Date(today.getFullYear(), today.getMonth() - 7, 1);

        if (dateType == 'dateFrom') {
            return dSeven.getFullYear() + '-' + String(dSeven.getMonth() + 1);
        } else {
            return today.getFullYear() + '-' + String(today.getMonth() + 1);
        }
    }

    getCustomFormattedDate(dateType) {
        if (dateType == 'dateFrom') {
            var date = new Date(),
                y = date.getFullYear(),
                m = date.getMonth();
            var firstDay = new Date(y, m, 1);
        } else {
            var firstDay = new Date();
        }

        var dd = String(firstDay.getDate()).padStart(2, '0');
        var mm = String(firstDay.getMonth() + 1).padStart(2, '0');
        var yyyy = firstDay.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    getFormattedDate(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }
    getDateFromTo(dateType) {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        if (dateType == 'dateTo') {
            var firstDay = new Date(y, m, 1);
        } else {
            date.setYear(date.getFullYear() - 7);
            var firstDay = new Date(date.getTime());
        }

        var dd = String(firstDay.getDate()).padStart(2, '0');
        var mm = String(firstDay.getMonth() + 1).padStart(2, '0');
        var yyyy = firstDay.getFullYear();
        var newdate = yyyy + '-' + mm + '-01';
        return newdate;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.fetchADashboardStatics();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async fetchADashboardStatics() {

        var userRole = this.props.selectedUserRole
        if (this.props.selectedUserRole === 'Admins') {
            var userRole = 'Admins';
        }
        if (this.props.selectedUserRole === 'Employees') {
            var userRole = 'Employees';
        }
        if (this.props.selectedUserRole === 'Distributors') {
            var userRole = 'Distributor';
        }
        if (this.props.selectedUserRole === 'StoreCP') {
            var userRole = 'StoreCP';
        }
        if (this.props.selectedUserRole === 'StoreOwners') {
            var userRole = 'StoreOwner';
        }
        if (this.props.selectedUserRole === 'GManager') {
            var userRole = 'GManager';
        }

        let bodyData = {
            UniqeID: this.props.UniqeID,
            userRole: userRole
        };
        
        await RestServices.fetchMyDashboardStatics(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                if (responseData.DashboardData.LastUpdated) {
                    if (this._isMounted) {
                        this.setState({
                            LastUpdated: responseData.DashboardData.LastUpdated,
                            AllStatics: responseData.DashboardData
                        });
                    }
                    this.fetch7Days();
                } else {
                    if (this._isMounted) {
                        this.setState({ loadingChart: false, loading: false });
                    }
                }
            });
    }

    fetch7Days = () => {
        if (this._isMounted) {
            this.setState({ showChart: 1, showDatePicker: false });
        }

        let chartData = [];
        let totalOrderCount = 0;
        let totalOrderValues = 0;
        let t_totalOrderCount = 0;
        let t_totalOrderValues = 0;
        
        this.state.AllStatics.Data7Days.forEach(async (OrderItem) => {
            totalOrderCount = parseInt(totalOrderCount) + OrderItem.Order;
            totalOrderValues =
                parseFloat(totalOrderValues) + parseFloat(OrderItem.OPS);
            t_totalOrderCount = parseInt(t_totalOrderCount) + OrderItem.t_Order;
            t_totalOrderValues =OrderItem.t_OPS?parseFloat(t_totalOrderValues) + parseFloat(OrderItem.t_OPS):parseFloat(t_totalOrderValues) ;    

            chartData.push({
                name: OrderItem.name,
                OPS: OrderItem.OPS,
                Order: OrderItem.Order,
                TenOPS: OrderItem.t_OPS,
                TenOrder: OrderItem.t_Order
            });
        });
        if (this._isMounted) {
            this.setState({
                chartData: chartData,
                totalOrderCount: totalOrderCount,
                totalOrderValues: parseInt(totalOrderValues.toFixed(0)),
                t_totalOrderCount: t_totalOrderCount,
                t_totalOrderValues: parseInt(t_totalOrderValues.toFixed(0))
            });
        }

        if (this._isMounted) {
            this.setState({ loadingChart: false, loading: false });
        }
    };

    fetch7Weeks = () => {
        if (this._isMounted) {
            this.setState({ showChart: 3, showDatePicker: false });
        }
        let chartData = [];
        let totalOrderCount = 0;
        let totalOrderValues = 0;
        let t_totalOrderCount = 0;
        let t_totalOrderValues = 0;
        this.state.AllStatics.Data7Weeks.forEach(async (OrderItem) => {
            totalOrderCount = parseInt(totalOrderCount) + OrderItem.Order;
            totalOrderValues =
                parseFloat(totalOrderValues) + parseFloat(OrderItem.OPS);

            t_totalOrderCount = parseInt(t_totalOrderCount) + OrderItem.t_Order;
            t_totalOrderValues =OrderItem.t_OPS?parseFloat(t_totalOrderValues) + parseFloat(OrderItem.t_OPS):parseFloat(t_totalOrderValues) ;    

            chartData.push({
                name: OrderItem.name,
                OPS: OrderItem.OPS,
                Order: OrderItem.Order,
                TenOPS: OrderItem.t_OPS,
                TenOrder: OrderItem.t_Order
            });
        });

        if (this._isMounted) {
            this.setState({
                chartData: chartData,
                totalOrderCount: totalOrderCount,
                totalOrderValues: parseInt(totalOrderValues.toFixed(0)),
                t_totalOrderCount: t_totalOrderCount,
                t_totalOrderValues: parseInt(t_totalOrderValues.toFixed(0))
            });
            this.setState({ loadingChart: false, loading: false });
        }
    };

    fetch7Month = () => {
        if (this._isMounted) {
            this.setState({ showChart: 2, showDatePicker: false });
        }
        let chartData = [];
        let totalOrderCount = 0;
        let totalOrderValues = 0;
        let t_totalOrderCount = 0;
        let t_totalOrderValues = 0;

        this.state.AllStatics.Data7Month.forEach(async (OrderItem) => {
            totalOrderCount = parseInt(totalOrderCount) + OrderItem.Order;
            totalOrderValues =
                parseFloat(totalOrderValues) + parseFloat(OrderItem.OPS);

                t_totalOrderCount = parseInt(t_totalOrderCount) + OrderItem.t_Order;
                t_totalOrderValues =OrderItem.t_OPS?parseFloat(t_totalOrderValues) + parseFloat(OrderItem.t_OPS):parseFloat(t_totalOrderValues) ;    

                chartData.push({
                    name: OrderItem.name,
                    OPS: OrderItem.OPS,
                    Order: OrderItem.Order,
                    TenOPS: OrderItem.t_OPS,
                    TenOrder: OrderItem.t_Order
                });
            });
    
            if (this._isMounted) {
                this.setState({
                    chartData: chartData,
                    totalOrderCount: totalOrderCount,
                    totalOrderValues: parseInt(totalOrderValues.toFixed(0)),
                    t_totalOrderCount: t_totalOrderCount,
                    t_totalOrderValues: parseInt(t_totalOrderValues.toFixed(0))
                });
                this.setState({ loadingChart: false, loading: false });
            }
    };

    fetch7DaysFiltered = () => {
        if (this._isMounted) {
            this.setState({ showChart: 1, showDatePicker: false });
        }
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var dateStart = new Date(date.getTime() - 7 * 24 * 60 * 60 * 1000);
        let chartData = [];
        let totalOrderCount = 0;
        let totalOrderValues = 0;
        let t_totalOrderCount = 0;
        let t_totalOrderValues = 0;

        this.state.last7DaysArray.forEach(async (dayName) => {
            var day = dayName;
            if (chartData.some((item) => day === item.name)) {
            } else {
                chartData.push({ name: day, OPS: 0, Order: 0 ,TenOPS: 0, TenOrder: 0 });
            }
        });

        if (this.state.AllStaticsFiltered.days) {
            this.state.AllStaticsFiltered.days.forEach(async (OrderItem) => {
                var OrderItemDate = new Date(OrderItem.Date);
                var day = OrderItem.Date;
                if (
                    this.state.AllSelectedTagsStoreTags.some(
                        (sitem) => OrderItem.Tag === sitem.tag
                    )
                ) {
                    if (chartData.some((item) => day === item.name)) {
                        chartData.some(function (el) {
                            if (el.name === day) {
                                var orderCount = OrderItem.OrderTotal
                                    ? OrderItem.OrderTotal
                                    : 0;
                                totalOrderCount =
                                    parseInt(totalOrderCount) + orderCount;
                                totalOrderValues =
                                    parseFloat(totalOrderValues) +
                                    parseFloat(OrderItem.OpsTotal);
                                el.Order = parseInt(el.Order) + orderCount;
                                el.OPS = (
                                    parseFloat(el.OPS) +
                                    parseFloat(OrderItem.OpsTotal)
                                ).toFixed(2);
                            }
                        });
                    }
                }
            });
        }

        if (this._isMounted) {
            this.setState({
                chartData: chartData,
                totalOrderCount: totalOrderCount,
                totalOrderValues: parseInt(totalOrderValues.toFixed(0))
            });
        }

        if (this._isMounted) {
            this.setState({ loadingChart: false, loading: false });
        }
    };

    fetch7WeeksFiltered = () => {
        if (this._isMounted) {
            this.setState({ showChart: 3, showDatePicker: false });
        }
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var first = date.getDate() - date.getDay();
        var dateStart = new Date(
            date.setDate(first) - 49 * 24 * 60 * 60 * 1000
        );

        let chartData = [];
        let totalOrderCount = 0;
        let totalOrderValues = 0;
        let t_totalOrderCount = 0;
        let t_totalOrderValues = 0;

        var oneJan = new Date(date.getFullYear(), 0, 1);
        var numberOfDays = Math.floor((date - oneJan) / (24 * 60 * 60 * 1000));
        var weekNumber = Math.ceil((date.getDay() + 1 + numberOfDays) / 7) - 1;
        var numberOfDaysStart = Math.floor(numberOfDays - 49);
        var weekNumber7 = Math.ceil(
            (date.getDay() + 1 + numberOfDaysStart) / 7
        );

        this.state.last7WeeksArray.forEach(async (weekName) => {
            var day = weekName;
            if (chartData.some((item) => day === item.name)) {
            } else {
                chartData.push({ name: day, OPS: 0, Order: 0,TenOPS: 0, TenOrder: 0 });
            }
        });

        if (this.state.AllStaticsFiltered.weeks) {
            this.state.AllStaticsFiltered.weeks.forEach(async (OrderItem) => {
                var day = OrderItem.week;

                if (
                    this.state.AllSelectedTagsStoreTags.some(
                        (sitem) => OrderItem.Tag === sitem.tag
                    )
                ) {
                    if (chartData.some((item) => day === item.name)) {
                        chartData.some(function (el) {
                            if (el.name === day) {
                                var orderCount = OrderItem.OrderTotal
                                    ? OrderItem.OrderTotal
                                    : 0;
                                totalOrderCount =
                                    parseInt(totalOrderCount) + orderCount;
                                totalOrderValues =
                                    parseFloat(totalOrderValues) +
                                    parseFloat(OrderItem.OpsTotal);
                                el.Order = parseInt(el.Order) + orderCount;
                                el.OPS = (
                                    parseFloat(el.OPS) +
                                    parseFloat(OrderItem.OpsTotal)
                                ).toFixed(2);
                            }
                        });
                    }
                }
            });
        }

        if (this._isMounted) {
            this.setState({
                chartData: chartData,
                totalOrderCount: totalOrderCount,
                totalOrderValues: parseInt(totalOrderValues.toFixed(0))
            });
            this.setState({ loadingChart: false, loading: false });
        }
    };

    fetch7MonthFiltered = () => {
        if (this._isMounted) {
            this.setState({ showChart: 2, showDatePicker: false });
        }
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        date.setMonth(date.getMonth() - 7);
        var dateStart = new Date(date.getTime());
        let chartData = [];

        let totalOrderCount = 0;
        let totalOrderValues = 0;
        let t_totalOrderCount = 0;
        let t_totalOrderValues = 0;

        this.state.last7MonthsArray.forEach(async (monthName) => {
            var day = monthName;
            if (chartData.some((item) => day === item.name)) {
            } else {
                chartData.push({ name: day, OPS: 0, Order: 0,TenOPS: 0, TenOrder: 0 });
            }
        });

        if (this.state.AllStaticsFiltered.months) {
            this.state.AllStaticsFiltered.months.forEach(async (OrderItem) => {
                var OrderItemDate = new Date(OrderItem.Date);
                var day = OrderItem.month;

                if (
                    this.state.AllSelectedTagsStoreTags.some(
                        (sitem) => OrderItem.Tag === sitem.tag
                    )
                ) {
                    if (chartData.some((item) => day === item.name)) {
                        chartData.some(function (el) {
                            if (el.name === day) {
                                var orderCount = OrderItem.OrderTotal
                                    ? OrderItem.OrderTotal
                                    : 0;
                                totalOrderCount =
                                    parseInt(totalOrderCount) + orderCount;
                                totalOrderValues =
                                    parseFloat(totalOrderValues) +
                                    parseFloat(OrderItem.OpsTotal);
                                el.Order = parseInt(el.Order) + orderCount;
                                el.OPS = (
                                    parseFloat(el.OPS) +
                                    parseFloat(OrderItem.OpsTotal)
                                ).toFixed(2);
                            }
                        });
                    }
                }
            });
        }

        if (this._isMounted) {
            this.setState({
                chartData: chartData,
                totalOrderCount: totalOrderCount,
                totalOrderValues: parseInt(totalOrderValues.toFixed(0))
            });
            this.setState({ loadingChart: false, loading: false });
        }
    };

    CustomRange = () => {
        this.fetchCustomStaticsBH(this.state.AllStaticsFiltered.customrange);
        if (this._isMounted) {
            this.setState({
                showDatePicker: true,
                showChart: 44,
                customFromDate: this.getCustomFormattedDate('dateFrom'),
                customToDate: this.getCustomFormattedDate('dateTo')
            });
        }
    };

    ApplyCustomRange = () => {
        if (this._isMounted) {
            this.setState({ showChart: 4, showDatePicker: true });
        }
        this.fetchCustomStatics();
    };

    async fetchCustomStatics() {
        var date1 = new Date(this.state.customFromDate);
        var date2 = new Date(this.state.customToDate);
        var date3 = new Date(this.state.fromDate);
        if (date2 < date1) {
            if (this._isMounted) {
                this.setState({
                    loading: false,
                    alert: 1,
                    alertMessage: 'To Date can not be Less Then From date...'
                });
            }
        } else {
            let AllSelectedTagsStoreTags = [];
            await this.state.AllSelectedTagsStoreTags.forEach((storetag) => {
                AllSelectedTagsStoreTags.push(storetag.tag);
            });

            var userRole = this.props.selectedUserRole
        if (this.props.selectedUserRole === 'Admins') {
            var userRole = 'Admins';
        }
        if (this.props.selectedUserRole === 'Employees') {
            var userRole = 'Employees';
        }
        if (this.props.selectedUserRole === 'Distributors') {
            var userRole = 'Distributor';
        }
        if (this.props.selectedUserRole === 'StoreCP') {
            var userRole = 'StoreCP';
        }
        if (this.props.selectedUserRole === 'StoreOwners') {
            var userRole = 'StoreOwner';
        }
        if (this.props.selectedUserRole === 'GManager') {
            var userRole = 'GManager';
        }

            let bodyData = {
                storeTag: AllSelectedTagsStoreTags,
                fromDate: this.state.customFromDate,
                toDate: this.state.customToDate,
                DateLabel: 'Date',
                TagLabel: 'Tag',
                userRole:userRole
            };
            this.setState({ loadingCustom: true });
            await RestServices.fetchMyDashboardCustomStatics(
                localStorage.getItem('FirebaseToken'),
                bodyData
            )
                .then((response) => response.json())
                .then(async (responseData) => {
					this.setState({ loadingCustom: false });
                    this.fetchCustomStaticsBH(responseData.customrange);
                });
        }
    }

    fetchCustomStaticsBH(AllStatics) {
        
        var date1 = new Date(this.state.customFromDate);
        var date2 = new Date(this.state.customToDate);
        var date3 = new Date(this.state.fromDate);

        var time_difference = date2.getTime() - date1.getTime();
        var days_difference = time_difference / (1000 * 60 * 60 * 24);

        var dateStart = new Date(this.state.customFromDate);
        let chartData = [];
        let totalOrderCount = 0;
        let totalOrderValues = 0;
        let t_totalOrderCount = 0;
        let t_totalOrderValues = 0;
        for (var i = 0; i <= days_difference; i++) {
            var firstDay = new Date(dateStart.getTime());
            var lastDay = new Date(
                firstDay.getTime() + 1 * 24 * 60 * 60 * 1000
            );
            var day =
                this.state.monthNames[firstDay.getMonth()] +
                ' ' +
                firstDay.getDate();

            if (chartData.some((item) => day === item.name)) {
            } else {
                chartData.push({ name: day, OPS: 0, Order: 0,TenOPS: 0, TenOrder: 0 });
            }
            dateStart = new Date(firstDay.getTime() + 1 * 24 * 60 * 60 * 1000);
        }

        if (AllStatics) {
            AllStatics.forEach(async (OrderItem) => {
                var OrderItemDate = new Date(OrderItem.Date);
                var day =
                    this.state.monthNames[OrderItemDate.getMonth()] +
                    ' ' +
                    OrderItemDate.getDate();

                if (
                    this.state.AllSelectedTagsStoreTags.some(
                        (sitem) => OrderItem.Tag === sitem.tag
                    )
                ) {
                    if (chartData.some((item) => day === item.name)) {
                        chartData.some(function (el) {
                            if (el.name === day) {
                                var orderCount = OrderItem.OrderTotal
                                    ? OrderItem.OrderTotal
                                    : 0;
                                totalOrderCount =
                                    parseInt(totalOrderCount) + orderCount;
                                totalOrderValues =
                                    parseFloat(totalOrderValues) +
                                    parseFloat(OrderItem.OpsTotal);

                                var t_orderCount = OrderItem.t_OrderTotal
                                    ? OrderItem.t_OrderTotal
                                    : 0;
                                t_totalOrderCount =
                                    parseInt(t_totalOrderCount) + t_orderCount;
                                t_totalOrderValues =OrderItem.t_OpsTotal?parseFloat(t_totalOrderValues) + parseFloat(OrderItem.t_OpsTotal):parseFloat(t_totalOrderValues) ;    


                                el.Order = parseInt(el.Order) + orderCount;
                                el.OPS = (
                                    parseFloat(el.OPS) +
                                    parseFloat(OrderItem.OpsTotal)
                                ).toFixed(2);

                                el.TenOrder = parseInt(el.TenOrder) + t_orderCount;
                                el.TenOPS = (
                                    parseFloat(el.TenOPS) +
                                    parseFloat(OrderItem.t_OpsTotal)
                                ).toFixed(2);
                            }
                        });
                    }
                }
            });
        }

        if (this._isMounted) {
            this.setState({
                chartData: chartData,
                totalOrderCount: totalOrderCount,
                totalOrderValues: parseInt(totalOrderValues.toFixed(0)),
                t_totalOrderCount: t_totalOrderCount,
                t_totalOrderValues: parseInt(t_totalOrderValues.toFixed(0))
            });

            this.setState({ alert: 0, loadingChart: false, loading: false });
        }
    }

    showOrderTypeValue= () => {
        if (this._isMounted) {
            this.setState({ showOrderType: this.state.showOrderType==1?0:1 });
        }
    };
    showOrderValue = () => {
        if (this._isMounted) {
            this.setState({ showOrder: 1 });
        }
    };
    showOrderCount = () => {
        if (this._isMounted) {
            this.setState({ showOrder: 2 });
        }
    };

    onSelect = (selectedList, selectedItem) => {
        if (this._isMounted) {
            this.setState({ selectedTags: selectedList });
            this.setState({ loadingChart: true });
        }
        setTimeout(() => {
            this.reloadChart();
        }, 1200);
    };

    onRemove = (selectedList, removedItem) => {
        if (this._isMounted) {
            this.setState({ selectedTags: selectedList });
            this.setState({ loadingChart: true });
        }
        setTimeout(() => {
            this.reloadChart();
        }, 1200);
    };

    onSearch = async (search_key) => {
        
        var userRole = this.props.selectedUserRole
        if (this.props.selectedUserRole === 'Admins') {
            var userRole = 'Admins';
        }
        if (this.props.selectedUserRole === 'Employees') {
            var userRole = 'Employees';
        }
        if (this.props.selectedUserRole === 'Distributors') {
            var userRole = 'Distributor';
        }
        if (this.props.selectedUserRole === 'StoreCP') {
            var userRole = 'StoreCP';
        }
        if (this.props.selectedUserRole === 'StoreOwners') {
            var userRole = 'StoreOwner';
        }
        if (this.props.selectedUserRole === 'GManager') {
            var userRole = 'GManager';
        }
        

        let bodyData = {
            search_key: search_key,
            search_by: 'StoreTag',
            UniqeID: this.props.user.ProfileUniqeID,
            userRole:userRole,
            perPage: 10
        };
        

        await RestServices.SearchStoreTagsMapping(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then(async (StoreTags) => {
                let tagOptions = [];
                await StoreTags.list.forEach(async (storetag) => {
                    tagOptions.push({ tag: storetag });
                });
                if (this._isMounted) {
                    this.setState({ tagOptions: tagOptions });
                }
            })
            .catch((err) => {});
    };

    async reloadChart() {
        let allStoreTags = [];

        if (this.state.selectedTags.length > 0) {
            await this.state.selectedTags.forEach((storetag) => {
                allStoreTags.push({ tag: storetag.tag });
            });
        } else {
            await this.state.tagOptions.forEach((storetag) => {
                allStoreTags.push({ tag: storetag.tag });
            });
        }

        
        if (this._isMounted) {
            this.setState({ AllSelectedTagsStoreTags: allStoreTags });
        }
        setTimeout(() => {
            this.reloadChartStatics();
        }, 500);
    }

    async reloadChartStatics() {
        
        if (this.state.showChart == 1) {
            this.fetch7DaysFiltered();
        }
        if (this.state.showChart == 2) {
            this.fetch7MonthFiltered();
        }
        if (this.state.showChart == 3) {
            this.fetch7WeeksFiltered();
        }
        if (this.state.showChart == 44) {
            this.fetchCustomStatics();
        }
    }

    render() {
        const chartData = this.state.chartData;
        const activeChart = this.state.showChart;
        const showOrder = this.state.showOrder;
        const showOrderType =this.state.showOrderType;
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.loading && <Spinner animation="border" />}
                {this.state.loadingChart && <Spinner animation="border" />}
                {this.state.loadingCustom && <Spinner animation="border" />}

                <Row>
                    <Col>
                        <br />
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <h4>IndiaBuys Order Summary</h4>
                        <p>Last Updated: {getFormattedDateTime(this.state.LastUpdated)}</p>
                        <hr />
                    </Col>
                </Row>

                {!this.state.loading && (
                    <div>
                        <Row>
                            <Col sm={2} className="filter_btn">
                                <p>
                                    <Button
                                        className={`full_width ${
                                            activeChart == 1 ? 'active' : ''
                                        }`}
                                        size="sm"
                                        variant={`${
                                            activeChart == 1
                                                ? 'info'
                                                : 'secondary'
                                        }`}
                                        onClick={this.fetch7Days}
                                    >
                                        Last 7 Days
                                    </Button>
                                </p>
                                <p>
                                    <Button
                                        className={`full_width ${
                                            activeChart == 3 ? 'active' : ''
                                        }`}
                                        size="sm"
                                        variant={`${
                                            activeChart == 3
                                                ? 'info'
                                                : 'secondary'
                                        }`}
                                        onClick={this.fetch7Weeks}
                                    >
                                        Last 7 Weeks
                                    </Button>
                                </p>
                                <p>
                                    <Button
                                        className={`full_width ${
                                            activeChart == 2 ? 'active' : ''
                                        }`}
                                        size="sm"
                                        variant={`${
                                            activeChart == 2
                                                ? 'info'
                                                : 'secondary'
                                        }`}
                                        onClick={this.fetch7Month}
                                    >
                                        Last 7 Months
                                    </Button>
                                </p>
                                <p>
                                    <Button
                                        className={`full_width ${
                                            activeChart == 44 ? 'active' : ''
                                        }`}
                                        size="sm"
                                        variant={`${
                                            activeChart == 44
                                                ? 'info'
                                                : 'secondary'
                                        }`}
                                        onClick={this.CustomRange}
                                    >
                                        Custom Range
                                    </Button>
                                </p>
                                {this.state.showDatePicker && (
                                    <div>
                                        <MaterialUIPickers
                                            id="date-picker-inline1"
                                            label="From Date"
                                            setDate={(date) => {
                                                if (this._isMounted) {
                                                    this.setState({
                                                        customFromDate:
                                                            this.getFormattedDate(
                                                                date
                                                            )
                                                    });
                                                }
                                            }}
                                        />
                                        <MaterialUIPickers
                                            id="date-picker-inline2"
                                            label="To Date"
                                            setDate={(date) => {
                                                if (this._isMounted) {
                                                    this.setState({
                                                        customToDate:
                                                            this.getFormattedDate(
                                                                date
                                                            )
                                                    });
                                                }
                                            }}
                                        />

                                        <Multiselect
                                            placeholder="Select Store"
                                            options={this.state.tagOptions}
                                            displayValue="tag"
                                            selectedValues={
                                                this.state.selectedTags
                                            }
                                            onSelect={this.onSelect}
                                            onRemove={this.onRemove}
                                            onSearch={this.onSearch}
                                        />

                                        <Button
                                            style={{ marginTop: '0.5rem' }}
                                            className={`full_width ${
                                                activeChart == 4 ? 'active' : ''
                                            }`}
                                            size="sm"
                                            variant={`${
                                                activeChart == 4
                                                    ? 'info'
                                                    : 'secondary'
                                            }`}
                                            onClick={this.ApplyCustomRange}
                                        >
                                            Apply
                                        </Button>
                                    </div>
                                )}
                            </Col>

                            <Col sm={10}>
                                <Row>
                                    <Col sm={8}></Col>
                                    {showOrderType == 1?<Col sm={4}>
                                        <p>
                                            Total Orders:{' '}
                                            {this.state.totalOrderCount.toLocaleString()}
                                        </p>
                                        <p>
                                            Total Order Values:{' '}
                                            {this.state.totalOrderValues.toLocaleString(
                                                'en-US',
                                                {
                                                    style: 'currency',
                                                    currency: 'INR'
                                                }
                                            )}
                                        </p>
                                    </Col>:<Col sm={4}>
                                        
                                        <p>
                                            Total Orders:{' '}
                                            {this.state.t_totalOrderCount.toLocaleString()}
                                        </p>
                                        <p>
                                            Total Order Values:{' '}
                                            {this.state.t_totalOrderValues.toLocaleString(
                                                'en-US',
                                                {
                                                    style: 'currency',
                                                    currency: 'INR'
                                                }
                                            )}
                                        </p>
                                    </Col>}
                                </Row>
                                <Row>
                                    <BarChart
                                        width={800}
                                        height={300}
                                        data={chartData}
                                    >
                                        {this.state.showOrder == 1 && showOrderType == 1 && (
                                            <Bar dataKey="OPS">
                                                {chartData.map(
                                                    (entry, index) => (
                                                        <Cell
                                                            cursor="pointer"
                                                            fill={this.generateColor()}
                                                            key={`cell-${index}`}
                                                        />
                                                    )
                                                )}
                                            </Bar>
                                        )}

                                        {this.state.showOrder == 1 && showOrderType == 0 && (
                                            <Bar dataKey="TenOPS">
                                                {chartData.map(
                                                    (entry, index) => (
                                                        <Cell
                                                            cursor="pointer"
                                                            fill={this.generateColor()}
                                                            key={`cell-${index}`}
                                                        />
                                                    )
                                                )}
                                            </Bar>
                                        )}

                                        {this.state.showOrder == 2 && showOrderType == 1 && (
                                            <Bar dataKey="Order">
                                                {chartData.map(
                                                    (entry, index) => (
                                                        <Cell
                                                            cursor="pointer"
                                                            fill={this.generateColor()}
                                                            key={`cell-${index}`}
                                                        />
                                                    )
                                                )}
                                            </Bar>
                                        )}

                                        {this.state.showOrder == 2 && showOrderType == 0 && (
                                            <Bar dataKey="TenOrder">
                                                {chartData.map(
                                                    (entry, index) => (
                                                        <Cell
                                                            cursor="pointer"
                                                            fill={this.generateColor()}
                                                            key={`cell-${index}`}
                                                        />
                                                    )
                                                )}
                                            </Bar>
                                        )}

                                        <XAxis dataKey="name" />
                                        {this.state.showOrder == 2 && showOrderType == 1 && (
                                            <YAxis dataKey="Order" />
                                        )}
                                        {this.state.showOrder == 2 && showOrderType == 0 && (
                                            <YAxis dataKey="TenOrder" />
                                        )}
                                        {this.state.showOrder == 1 && showOrderType == 1 && (
                                            <YAxis dataKey="OPS" />
                                        )}
                                        {this.state.showOrder == 1 && showOrderType == 0 && (
                                            <YAxis dataKey="TenOPS" />
                                        )}

                                        <Tooltip
                                            cursor={{ fill: 'transparent' }}
                                        />
                                    </BarChart>
                                </Row>

                                <Row>
                                <Col></Col>
                                <Col>
                                    <Button
                                            className={`full_width ${
                                                showOrderType == 0 ? 'active' : ''
                                            }`}
                                            variant={`${
                                                showOrderType == 0
                                                    ? 'info'
                                                    : 'secondary'
                                            }`}
                                            onClick={this.showOrderTypeValue}
                                        >
                                            Tentive
                                        </Button>
                                    </Col>
                                    <Col>
                                    <Button
                                            className={`full_width ${
                                                showOrderType == 1 ? 'active' : ''
                                            }`}
                                            variant={`${
                                                showOrderType == 1
                                                    ? 'info'
                                                    : 'secondary'
                                            }`}
                                            onClick={this.showOrderTypeValue}
                                        >
                                            Approved
                                        </Button>
                                    </Col>
                                    <Col>
                                        <Button
                                            className={`full_width ${
                                                showOrder == 1 ? 'active' : ''
                                            }`}
                                            variant={`${
                                                showOrder == 1
                                                    ? 'info'
                                                    : 'secondary'
                                            }`}
                                            onClick={this.showOrderValue}
                                        >
                                            Order Value
                                        </Button>
                                    </Col>

                                    <Col>
                                        <Button
                                            className={`full_width ${
                                                showOrder == 2 ? 'active' : ''
                                            }`}
                                            variant={`${
                                                showOrder == 2
                                                    ? 'info'
                                                    : 'secondary'
                                            }`}
                                            onClick={this.showOrderCount}
                                        >
                                            Order Count
                                        </Button>
                                    </Col>

                                    <Col></Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                )}
            </Container>
        );
    }
}

export default ProfileChart;
